import { upperFirst } from 'lodash';

export const apiUri = process.env.REACT_APP_ADMIN_API_URI;

export const websiteUrl = process.env.REACT_APP_WEBSITE_URL;

export const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID;

export const userPoolWebClientId = process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID;

export const carrierName = 'transportör';

export const nonCarrierName = 'transportköpare';

export const carrierNameCapitalized = upperFirst(carrierName);

export const nonCarrierNameCapitalized = upperFirst(nonCarrierName);
